import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_EMPLOYEES](state, data) {
    console.log('mutation ', data)
    state.allEmployees = data
  },
}
